import React from 'react';
import { NumberField, TextField, useFieldHelper } from 'framework/ui/field';
import { ControlledList, DataGridLayout } from 'framework/list';
import PurchaseAmountField from 'domain/finance/purchaseOrder/shared/field/PurchaseAmountField';
import PurchaseTotalAmountField from 'domain/finance/purchaseOrder/shared/field/PurchaseTotalAmountField';

const PurchasesListField = ({
  source,
  isSensitiveDataIsShown,
}: {
  source: string;
  isSensitiveDataIsShown?: boolean;
}) => {
  const { getValue } = useFieldHelper({ source });
  const { getValue: getPurchaseSubTotals } = useFieldHelper({ source: 'purchaseSubTotals' });
  const transfers = (getValue() as any) || [];
  const purchaseSubTotals = getPurchaseSubTotals() as any;

  return (
    <ControlledList data={{ items: transfers, totalPages: 1, totalElements: transfers.length }}>
      <DataGridLayout
        sxTableWrapper={{
          '& table.MuiTable-root': {
            minWidth: '1080px',
          },
        }}
      >
        {
          [
            <TextField source="name" label="Name" width="50%" />,
            isSensitiveDataIsShown && (
              <PurchaseAmountField
                source="id"
                amountSource="amount"
                currencySource="currency"
                label="Unit price"
                width="50%"
                purchaseSubTotals={purchaseSubTotals}
              />
            ),
            <NumberField source="quantity" label="Quantity" width="50%" displayZeroValue={false} />,
            isSensitiveDataIsShown && (
              <PurchaseTotalAmountField
                source="id"
                amountSource="amount"
                currencySource="currency"
                quantitySource="quantity"
                label="Total price"
                width="50%"
                purchaseSubTotals={purchaseSubTotals}
              />
            ),
          ].filter(Boolean) as React.ReactElement[]
        }
      </DataGridLayout>
    </ControlledList>
  );
};

export default PurchasesListField;
